export class HttpError {
    static readonly BadRequest = 400;
    static readonly Unauthorized = 401;
    static readonly Forbidden = 403;
    static readonly NotFound = 404;
    static readonly TimeOut = 408;
    static readonly Conflict = 409;
    static readonly TooManyRequests = 429;
    static readonly InternalServerError = 500;
}
